<div class="offer-stage" [attr.category]="stage().category" [class.big]="isBig()">
  <rt-truncate>
    {{ stage().name }}
  </rt-truncate>
</div>
